import component from './UiTag.vue'
export default component
